// import { FlowExecutionContext } from "../../../../../pages/execution/state";

import { NodeTaskData } from "components/flow/nodes/mapper";

const ForkJoinDynamicTask = ({ nodeData }: { nodeData: NodeTaskData }) => {
  // const { onCollapseDynamic } = useContext(FlowExecutionContext);
  const { task } = nodeData;

  return (
    <div style={{ marginTop: "0px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "45px",
          }}
        >
          {/* {collapsed === false && task.executionData?.executed ? (
            <button
              onClick={() => null}
              style={{
                height: "30px",
                fontSize: "9pt",
                marginTop: "15px",
              }}
            >
              Collapse
            </button>
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default ForkJoinDynamicTask;
